import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import { DialogTitle, Typography, Box, DialogContent } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "calc(100% - 32px)",
    maxWidth: "600px",
    margin: "16px",
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function SampleImageModal({ imageModal, setImageModal, imageSrc, imageSrc2, title, promptText, promptText2 }) {
  const handleClose = () => setImageModal(false);

  return (
    <BootstrapDialog
      onClose={handleClose}
      scroll="body"
      aria-labelledby="customized-dialog-title"
      open={imageModal}
    >
      <Box
        sx={{
          backgroundColor: "#011c34",
          color: "#fff",
          width: "100%",
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2, borderBottom: "2px solid #9a9ead54" }}
          id="customized-dialog-title"
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2 text-white">
              <Typography variant="h6">{title || "Sample Image"}</Typography>
            </div>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent sx={{ overflowX: "hidden", display: "flex", flexDirection: "column", alignItems: "center" }}>
          {promptText && (
            <div className="mb-3 w-100 text-center">
              <p className="mb-1" style={{ fontSize: "14px" }}>
                <span className="fw-bold" style={{ color: "#ffa21f" }}>Prompt:</span>{' '}
                <span className="text-white">{promptText}</span>
              </p>
            </div>
          )}
          <img
            src={imageSrc}
            alt="Sample"
            style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", marginTop: "10px" }}
          />

          {promptText2 && (
            <div className="mb-3 w-100 text-center">
              <p className="mb-1 mt-3" style={{ fontSize: "14px" }}>
                <span className="fw-bold" style={{ color: "#ffa21f" }}>Edit Prompt:</span>{' '}
                <span className="text-white">{promptText2}</span>
              </p>
            </div>
          )}
          {imageSrc2 && (
            <img
              src={imageSrc2}
              alt="Sample"
              style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", marginTop: "10px" }}
            />
          )}
        </DialogContent>
      </Box>
    </BootstrapDialog>
  );
}
